<template>
	<div class="container">
		<div class="content">
			<div class="circle-title" v-if="userId">我的圈子<span class="circle-title-bg"></span></div>
			<div class="circle-type" v-if="userId">
				<div class="circle-list-wrap" v-if="joinCircleList.length>4&&joinMoreClick==1">
					<div class="circle-list" @click="toCircleIndex(item.id)" v-for="(item, index) in joinCircleList" :key="index">
						<div class="circle-list-l" @click="toCircleDetail(item.id)">
							<img :src="item.icon||require('@/assets/default-img.png')"/>
						</div>
						<div class="circle-list-r" @click="toCircleDetail(item.id)">
							<h3 >{{item.circleName}}</h3>
							<div class="circle-num">{{item.postNum}}帖子</div>
						</div>
					</div>
				</div>
				<div class="circle-list-wrap" v-else>
					<div class="circle-list"  @click="toCircleIndex(item.id)" v-for="(item, index) in joinCircleList" :key="index">
						<div class="circle-list-l" v-if="index<4">
							<img :src="item.icon||require('@/assets/default-img.png')"/>
						</div>
						<div class="circle-list-r" v-if="index<4">
							<h3>{{item.circleName}}</h3>
							<div class="circle-num">{{item.postNum}}帖子</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'UserInfoCirclList',
		components: {
		},
		data(){
			return {
				circleUserId: '',
				joinCircleList: [],
				userId: ''
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.circleUserId = this.$route.query.userId
			if(this.userId) {
				this.getList()
			}
		},
		methods: {
			
			toCircleIndex(id){
				this.$router.push({
					path: '/circleIndex?id='+id
				})
			},
			//获取加入的圈子
			async getList(){
				let param = {
					userId: this.userId,
					otherUserId: this.circleUserId,
				}
				ajaxParam(param)
				const res = await post('v1/circle/otherJoinCircleList', qs.stringify(param))
				if(res.data.code==200){
					let list = res.data.list
					this.joinCircleList = list
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.container{
		width: 1200px;
		margin: 20px auto;
		box-sizing: border-box;

		.content {
			padding: 0 40px;
			background: #fff;
			.circle-title{
				height: 40px;
				border-bottom: 1px solid rgba(50, 50, 51, 0.14);
				line-height: 40px;
				font-weight: bold;
				position: relative;
				margin-bottom: 15px;
				.circle-title-bg{
					position: absolute;
					left: 0;
					bottom: 0;
					width: 56px;
					height: 4px;
					background: #DD0515;
				}
			}
			.circle-type{
				padding-bottom: 15px;
				h1{
					//margin: 15px 0 0;
					font-size: 12px;
					color: #666;
					opacity: .6;
				}
			}
			.circle-list-wrap{
				display: flex;
				flex-wrap: wrap;
				margin-top: 8px;
				.circle-list{
					display: flex;
					align-items: center;
					width: 25%;
					margin-bottom: 10px;
					padding: 0 10px;
					cursor: pointer;
					box-sizing: border-box;
					.circle-list-l{
						position:relative;
						.icon-circle{
							width:14px;
							height: 14px;
							background: #DD0515;
							border-radius: 50%;
							line-height: 14px;
							text-align: center;
							font-size: 12px;
							color:#fff;
							position: absolute;
							right: 0;
							top: 0
						}
						img{
							width: 50px;
							height: 50px;
							margin: 0 auto;
							border-radius: 15px;
						}
					}
					.circle-list-r{
						margin-left: 10px;
						overflow: hidden;
						h3{
							width: 100%;
							font-size: 14px;
							font-weight: bold;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							text-align: center;
							line-height: 30px;
						}
						.circle-num{
							margin: 4px 0 10px;
							opacity: .7;
							font-size: 12px;
						}
					}
					
					.enter-btn{
						width: 62px;
						height: 22px;
						border-radius: 14px;
						border: 1px solid #DD0515;
						line-height: 22px;
						text-align: center;
						font-size: 12px;
						color: #DD0515;
					}
					.entered{
						background: rgba(50,50,50,.1);
						border-color: rgba(50,50,50,.1);
						color: rgba(50,50,50,.3);
					}
				}
			}
		}
	}
</style>
